import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
} from "react-router-dom";
import Login from "./components/Login/Login";
import PatientClaim from "./components/patientComponents/PatientClaim";
import ClaimsPatient from "././components/patientComponents/claims";
import Admin from "./components/adminComponents/AdminNotif";
import AdminHome from "./components/adminComponents/AdminHome";
import AdminResources from "./components/adminComponents/AdminResources";
import LandingPage from "./components/LandingPage";
import Listen from "./components/patientComponents/Listen";
import PatientHome from "./components/patientComponents/PatientHome";
import Insurance_Provider from "./components/insuranceComponents/insurance_sign.js";
import AdminInsurance from "./components/adminComponents/AdminInsurance";
import SignUp from "./components/Login/SignupPatient";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Reg from "./components/temp/register";
import Log from "./components/temp/login";
import Profile from "./components/temp/profile";
import View from "./info";
import ViewSupply from "./info_supplychain";
import AdminSupplyChain from "./components/adminComponents/adminsupplychain";
// import "./index.css"

function Home() {
  function RequireAuth({ children }) {
    const data = JSON.parse(localStorage.getItem("creds"));
    if (data) {
      return children;
    }
    alert("You must login to view this page");
    return <Navigate to="/login" />;
  }
  function RequireAdmin({ children }) {
    const data = JSON.parse(localStorage.getItem("creds"));
    if (!data) {
      alert("You must login to view this page");
      return <Navigate to="/login" />;
    }
    if (data.type != "A") {
      alert("You must be an admin to view this page");
      return <Navigate to="/" />;
    }
    return children;
  }
  function RequirePatient({ children }) {
    const data = JSON.parse(localStorage.getItem("creds"));
    if (!data) {
      alert("You must login to view this page");
      return <Navigate to="/login" />;
    }
    if (data.type != "P") {
      alert("You must be a patient to view this page");
      return <Navigate to="/" />;
    }
    return children;
  }

  function RequireInsurance({ children }) {
    const data = JSON.parse(localStorage.getItem("creds"));
    if (!data) {
      alert("You must login to view this page");
      return <Navigate to="/login" />;
    }
    if (data.type != "I") {
      alert("You must be an insurance provider to view this page");
      return <Navigate to="/" />;
    }
    return children;
  }

  function Logout() {
    const data = JSON.parse(localStorage.getItem("creds"));
    if (!data) {
      alert("You must login first to logout");
      return (window.location = "/login");
    }
    localStorage.removeItem("creds");
    return (window.location = "/");
  }

  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" exact element={<LandingPage />} />
          <Route path="/login" element={<Log />} />
          <Route path="/register" element={<Reg />} />
          <Route path="/logout" element={<Logout />} />

          {/* <Route element={<RequireAuth />}> */}
          <Route
            path="/profile"
            element={
              <RequireAuth>
                <Profile />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/home"
            element={
              <RequireAdmin>
                <AdminHome />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/notif"
            element={
              <RequireAdmin>
                <Admin />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/insurance"
            element={
              <RequireAdmin>
                <AdminInsurance />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/resources"
            element={
              <RequireAdmin>
                <AdminResources />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/supplychain"
            element={
              <RequireAdmin>
                <AdminSupplyChain />
              </RequireAdmin>
            }
          />

          <Route
            path="/patient/notifs"
            element={
              <RequirePatient>
                <Listen />
              </RequirePatient>
            }
          />
          <Route
            path="/patient/claim"
            element={
              <RequirePatient>
                <PatientClaim />
              </RequirePatient>
            }
          />
          <Route
            path="/patient/home"
            element={
              <RequirePatient>
                <PatientHome />
              </RequirePatient>
            }
          />
          <Route
            path="/patient/list"
            element={
              <RequirePatient>
                <ClaimsPatient />
              </RequirePatient>
            }
          />
          <Route
            path="/provider"
            element={
              <RequireInsurance>
                <Insurance_Provider />
              </RequireInsurance>
            }
          />
          {/* Insurance Provider Routes */}
          <Route element={<RequireInsurance />}>
            <Route path="/provider" element={<Insurance_Provider />} />
          </Route>
          <Route>
            <Route path="/view" element={<View />} />
          </Route>
          <Route>
            <Route path="/viewsupply" element={<ViewSupply />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default Home;
